import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * 工單異動單 create／update payload（camel → snake）。
 * 僅送 scrapQty／cancelQty／mtrSubstitutions／issueReason／remark／updatedAt；
 * 擬議費用 `expenses`（已轉好的 `{id?,name,amount}[]`）出現時連同 `expensesRevision`。
 * 省略 `expenses`＝沿用工單有效費用；不可送 `expenses: null`。
 */
export function serializeWorkOrderAmendmentWrite(values) {
  const payload = {
    scrapQty: toQty(values?.scrapQty),
    cancelQty: toQty(values?.cancelQty),
    mtrSubstitutions: mapMtrSubstitutions(values?.mtrSubstitutions),
    issueReason: values?.issueReason ?? null,
    remark: values?.remark ?? null,
  };

  if (Array.isArray(values?.expenses)) {
    payload.expenses = values.expenses;
    payload.expensesRevision = values?.expensesRevision ?? null;
  }

  const updatedAt = values?.updatedAt ?? values?.record?.updatedAt ?? null;
  if (updatedAt != null && updatedAt !== '') {
    payload.updatedAt = updatedAt;
  }

  return keysToSnake(payload);
}

function toQty(value) {
  if (value === '' || value == null) {
    return null;
  }
  return Number(value);
}

function mapMtrSubstitutions(rows = []) {
  // BE：只收 source_group_mtr_id／to_mtr_id／remark；from_mtr 由後端自現選料推導（禁寫 from_mtr_id）
  return (rows ?? []).map((row) => ({
    sourceGroupMtrId: row?.sourceGroupMtrId ?? null,
    toMtrId: row?.toMtrId ?? null,
    remark: row?.remark ?? null,
  }));
}
